let columnsJson = [
    {prop:'id',label:'发票ID',fixed:'left',width:'80'},
    {prop:'change_month',label:'记账月份',fixed:'left',width:'80'},
    {prop:'applicant',label:'申请人',fixed:'left',width:'100'},
    {prop:'company',label:'签约公司',fixed:'',width:'100'},
    {prop:'order_month',label:'消耗月份',fixed:'',width:'100',manyOrder:true},
    {prop:'saleman',label:'销售人员',fixed:'',width:'100',manyOrder:true},
    {prop:'handler',label:'经手人',fixed:'',width:'100',manyOrder:true},
    {prop:'customer_name',label:'开票客户名称',fixed:'',width:'100'},
    {prop:'project_name',label:'项目名称',fixed:'',width:'100',manyOrder:true},
    {prop:'platform_name',label:'投放平台',fixed:'',width:'100',manyOrder:true},
    {prop:'media_name',label:'媒体名称',fixed:'',width:'100',manyOrder:true},
    {prop:'amount_format',label:'订单金额',fixed:'',width:'100',manyOrder:true},
    {prop:'final_amount_format',label:'修改后的订单最终收入金额',fixed:'',width:'150',manyOrder:true},
    {prop:'invoice_num',label:'开票次数',fixed:'',width:'100',manyOrder:true},
    {prop:'invoice_amount',label:'开票金额',fixed:'',width:'100'},
    {prop:'invoice_type',label:'发票类型',fixed:'',width:'100'},
    {prop:'service_type',label:'发票服务类型',fixed:'',width:'100'},
    {prop:'invoice_note',label:'发票备注',fixed:'',width:'100'},
    {prop:'title',label:'名称(开票信息)',fixed:'',width:'100'},
    {prop:'tax_id',label:'税号(开票信息)',fixed:'',width:'100'},
    {prop:'address_tel',label:'地址/电话(开票信息)',fixed:'',width:'100'},
    {prop:'bank_account',label:'银行/账号(开票信息)',fixed:'',width:'100'},
    {prop:'consignee',label:'收件人',fixed:'',width:'100'},
    {prop:'contacts',label:'联系人',fixed:'',width:'100'},
    {prop:'contact_number',label:'联系方式',fixed:'',width:'100'},
    {prop:'mail_address',label:'邮寄地址',fixed:'',width:'100'},
    {prop:'invoiced_time',label:'开票日期(出纳标记)',fixed:'',width:'120'},
    {prop:'is_invoiced',label:'是否标记开票',fixed:'',width:'100'},
    {prop:'applicant_time',label:'系统申请日期',fixed:'',width:'100'},
    {prop:'files',label:'附件列表',fixed:'',width:'200'},
]
export default columnsJson;


// WEBPACK FOOTER //
// ./src/components/BeforeApril/json/invoices_list.js